import { TwinConversationType } from 'api/model'
import Selector from 'components/Selector'

const ConversationTypes = [
  TwinConversationType.chat,
  TwinConversationType.email,
  TwinConversationType.email_enh,
  TwinConversationType.email_1s,
  TwinConversationType.email_1s_enh,
  TwinConversationType.email_class,
  TwinConversationType.email_insights,
  TwinConversationType.email_style,
]

// used for email debug functionality
const ConversationTypeSelector = ({
  disabled,
  conversationType,
  setConversationType,
  isDarkBackdrop,
}: {
  disabled?: boolean
  conversationType: TwinConversationType
  setConversationType: (conversationType: TwinConversationType) => void
  isDarkBackdrop: boolean // used to conditionally style label text color, sometimes this component is on a light / dark backdrop
}) => {
  return (
    <Selector
      id="conversation-type-selector"
      label="Conversation Type"
      disabled={disabled}
      option={conversationType}
      options={ConversationTypes}
      setOption={setConversationType}
      isDarkBackdrop={isDarkBackdrop}
      width="240px"
    />
  )
}

export default ConversationTypeSelector
